import { Record } from "../types";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export async function getRecords(period_id: number): Promise<Record[]> {
  let resp = await fetch(`${API_URL}/periods/${period_id}/records`);

  if (!resp.ok) {
    throw new Error(`Request failed with status ${resp.status}`);
  }

  let data: Record[] = await resp.json();
  return data;
}

export async function getRecord(
  period_id: number,
  record_id: number,
): Promise<Record> {
  let resp = await fetch(
    `${API_URL}/periods/${period_id}/records/${record_id}`,
  );

  if (!resp.ok) {
    throw new Error(`Request failed with status ${resp.status}`);
  }

  let data: Record = await resp.json();
  return data;
}

export async function insertRecord(record: Record): Promise<Record> {
  console.log("Inserting record");
  let resp = await fetch(`${API_URL}/periods/${record.period_id}/records`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(record),
  });

  if (!resp.ok) {
    throw new Error(`Request failed with status ${resp.status}`);
  }

  let data: Record = await resp.json();
  return data;
}

export async function updateRecord(record: Record): Promise<Record> {
  let resp = await fetch(
    `${API_URL}/periods/${record.period_id}/records/${record.id}`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(record),
    },
  );

  if (!resp.ok) {
    throw new Error(`Request failed with status ${resp.status}`);
  }

  let data: Record = await resp.json();
  return data;
}

export async function deleteRecord(period_id: number, record_id: number) {
  let resp = await fetch(
    `${API_URL}/periods/${period_id}/records/${record_id}`,
    {
      method: "DELETE",
    },
  );

  if (!resp.ok) {
    throw new Error(`Request failed with status ${resp.status}`);
  }

  let data: { deleted: Record } = await resp.json();
  return data;
}
